/*

Lalitha 10/27/2022 3225736869 night jobs UX changes
Rajesh 11/14/2022 3225736869 Add night jobs New UX.
Lalitha  11/28/2022 3225736869 import SaveAleart and SelectTabContextProvider
Dilip 11/28/2022 3225736869 added unsave alert popup
Ashraf 12/16/2022 3225736869 fixed role based access

*/
import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import NightJob from './Jobs';
import {useSelector} from 'react-redux';
import AddNightJobs from './Jobs/AddNightJobs';
import SaveAlert from '../../../components/DialogBox/SaveAlert';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function BreTabs({value, setValue}) {
  const classes = useStyles();
  // const [groupId, setGroupId] = React.useState('');
  const groupId = '';
  const [tabValue, setTabValue] = React.useState(0);
  const [roleDataNJobs, setRoleDataNJobs] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const {setGlobalFieldRow, sample, setNewTabValue} =
    useContext(SelectTabContextProvider);
  const handleTabChange = (event, newValue) => {
    if (tabValue === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
    setGlobalFieldRow(false);
  };

  useEffect(() => {
    setRoleDataNJobs(roleData ? roleData?.window?.['Scheduler']?.SC : {});
  }, [roleData]);
  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {open && (
          <SaveAlert title="Skip Schedule" value={`Are you sure to proceed without saving schedule ?`} 
            setTabValue={setTabValue} setOpen={setOpen} open={open} tabvalue={tabValue} />
        )}
        {tabValue === 0 && (
          <NightJob
            roleDataNJobs={roleDataNJobs}
            setTabValue={setTabValue}
            groupId={groupId}
            setSelected={setSelected}
          />
        )}
        {tabValue === 1 && <AddNightJobs selected={selected} setTabValue={setTabValue} tabValue={tabValue} handleTabChange={handleTabChange} />}
      </div>
    </div>
  );
}
